// extracted by mini-css-extract-plugin
module.exports = {"root":"StaticMap_root__ktylk","iconContainer":"StaticMap_iconContainer__t9aLJ","iconCircle":"StaticMap_iconCircle__VwUtJ","hide":"StaticMap_hide__zFNba"};